export default __webpack_public_path__ + "static/media/pp-register-large2.42de232c.jpg";